import { Directive } from '@angular/core';

@Directive({
  selector: '[tiimeSelectOptions]',
  host: {
    class: 'tiime-select-options'
  }
})
export class SelectOptionsDirective {}
